module.exports = __webpack_public_path__ + "media/images/builder/1coverimage-11db42c9d1da565788027442af6a339e.png";